import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8">
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="p-3 rounded-full bg-yellow-500 text-white shadow-lg hover:bg-yellow-600 transition duration-300"
        >
          <FaArrowUp className="text-2xl md:text-3xl" />
        </button>
      )}
    </div>
  );
};

export default ScrollToTopButton;
